export const refillSums: number[] = [100, 500, 1000, 2500, 5000, 10000, 50000, 100000];

export const refillPrepaidSums: number[] = [500, 1000, 2500, 5000, 10000, 20000];
